import { MAP_GEOMETRY_TYPE } from "./mapGeometryType";
export default {
    [MAP_GEOMETRY_TYPE.POINT]: "icon-map-location-anchor",
    [MAP_GEOMETRY_TYPE.LINE]: "icon-path",
    [MAP_GEOMETRY_TYPE.AREA]: "icon-location-area"
};
